import { commercialPageConstants, ROUTES } from '../../constants';

const initialState = {
    selectedMenu: ROUTES.HOME,
}

export default function menuReducer(state = initialState, action) {
    switch (action.type) {
        case commercialPageConstants.MENUUPDATE: {
            return {
                ...state,
                selectedMenu: action.payload.selectedMenu
            }
        }
        default:
            return state
    }
}